// import axios from 'axios';
// import { ElMessage } from 'element-plus';
// import { useMainStore } from '@/pinia';
// // import { useRouter } from 'vue-router';
// import router from '@/router';
// let baseURL = process.env.VUE_APP_API_BASE_URL;
// axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';
// axios.defaults.baseURL = baseURL;

// const getToken = () => {
//   return localStorage.getItem('token');
// };

// const getTokenTimestamp = () => {
//   return Number(localStorage.getItem('tokenTimestamp'));
// };

// const getTeamId = () => {
//   const store = useMainStore();
//   return store.teamInfo?.id || localStorage.getItem('teamId') || '';
// };

// const setToken = (token: string): void => {
//   (axios.defaults.headers as any).Authorization = `${token}`;
//   localStorage.setItem('token', `${token}`);
//   localStorage.setItem('tokenTimestamp', new Date().getTime().toString());
// };

// // eslint-disable-next-line no-console
// if (process.env.NODE_ENV === 'development') {
//   // (axios.defaults.headers as any).Authorization = `Bearer ${getToken()}`;
// }

// axios.interceptors.request.use(
//   (config) => {
//     // console.log(config);
//     // if(!config.headers) config.headers = {};
//     if (!config.url?.includes('/app/accountLogin')) {
//       config.headers = {};
//       let token = getToken();
//       if (token == null || token == 'null') token = '';
//       config.headers['Authorization'] = token;
//       config.headers['App-Team-Id'] = getTeamId();
//     }
//     return config;
//   },
//   (error) => {
//     // eslint-disable-next-line no-console
//     console.log(error);
//     return Promise.reject(error);
//   }
// );

// // axios.defaults.timeout = 1000;

// // 错误码字典
// const ERROR_CODE_MAP: Record<number, string> = {
//   5001: '登录已过期,请重新登录',
//   8001: '权益不足',
//   4001: '参数错误',
//   5000: '服务器错误',
// };

// // 统一错误处理
// const handleError = (code: number, msg?: string) => {
//   const errorMsg = msg || ERROR_CODE_MAP[code] || '未知错误';
//   if (code === 5001) {
//     // 登录失效处理
//     localStorage.setItem('token', '');
//     localStorage.setItem('teamId', '');
//     router.push('/login');
//   }
//   ElMessage.error(errorMsg);
// };

// axios.interceptors.response.use(
//   (res) => {
//     const { data, status } = res;

//     if (status === 200) {
//       // 处理业务错误码
//       if (data.code && data.code !== 200) {
//         handleError(data.code, data.msg);
//         // 8001为特殊提示,使用warning
//         if (data.code === 8001) {
//           ElMessage.warning(data.msg);
//         }
//       }
//       return res;
//     }
//   },
//   (error) => {
//     if (error.response) {
//       const { status, data } = error.response;
//       if (status === 429) {
//         ElMessage.warning(data.msg || '请求过于频繁,请稍后再试');
//       } else {
//         // 处理其他HTTP错误
//         handleError(status, data.msg);
//       }
//     } else {
//       ElMessage.error('网络连接失败');
//     }
//     return Promise.reject(error);
//   }
// );

// export { baseURL, setToken, getToken, getTeamId, getTokenTimestamp };
// export default axios;

import request, { setToken, getToken, getTeamId } from '@/utils/request/index';

// 导出工具方法和请求实例
export { setToken, getToken, getTeamId };
export default request;
